import { ExpensesCustomizationConfigResourceTypeEnum } from 'generated/resources/graphql'
import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'

import { CustomizationField, isMandatory } from 'modules/expenses/hooks/useExpensesCustomization'

export interface FormContext {
  customizationFields: CustomizationField[]
  resourceType: ExpensesCustomizationConfigResourceTypeEnum
}

const defaultRequiredMessage = () => ({
  message: i18n.t('expenses_v2.forms.errors.required'),
})

export const EffectiveOnFieldSchema = ({ customizationFields, resourceType }: FormContext) => {
  return z.object({
    effectiveOn: z
      .string()
      .optional()
      .refine(
        (effectiveOn) =>
          isMandatory('effective_on', resourceType, customizationFields) ? !!effectiveOn : true,
        defaultRequiredMessage()
      ),
  })
}
